import { isIOS } from "react-device-detect";
import qrCode from "@assets/img-qr-code-app-download-black.png";
import player from "@assets/podcasts/img-podcast-player.png";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import {
  ANDROID_APP_LINK,
  IOS_APP_LINK,
} from "@components/Footer/utils/constant";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

/**
 * Promote App Download banner version 1. Use in the side column of the podcasts page above imu1 ad.
 */
const PodcastsPromoteBannerVersion1 = (): React.ReactElement => {
  const { isScreenMD } = useWindowSize();

  return (
    <>
      <div
        className={cn(
          "flex flex-col items-center justify-center overflow-hidden bg-gray-225 p-6 text-gray-850",
          "md:flex-row lg:flex-col"
        )}
        data-testid="podcasts-promote-banner-version-1-component"
      >
        <div
          className={cn(
            "w-[200px] rounded-lg border-2 border-gray-175 ring-1 ring-inset ring-gray-175",
            "shadow-[0_6.316px_23.684px_0_rgba(0,0,0,0.08)]",
            "-mt-20 mb-9 rotate-[6deg] md:mb-0 md:mt-0 md:rotate-0 lg:-mt-20 lg:mb-8 lg:rotate-[6deg]"
          )}
        >
          <img
            src={player}
            className="block w-full rounded-lg"
            width={150}
            height={190}
            alt="Podcast Player"
          />
        </div>

        <div className="md:pl-8 lg:pl-0">
          <p
            className={cn(
              "mb-4 font-lct text-3xl leading-tight tracking-[0.01em] text-gray-850 xs:whitespace-pre-wrap ",
              "text-center md:pt-2 md:text-left md:text-xl lg:pt-0 lg:text-center lg:text-3xl"
            )}
          >
            {"Discover a better way \nto listen"}
          </p>

          {isScreenMD ? (
            <div className="mx-auto hidden md:mx-0 md:block md:w-[90px] lg:mx-auto lg:w-[128px]">
              <img
                src={qrCode}
                className="rounded-md bg-white md:mx-0 md:p-2 lg:p-[10px]"
                width={128}
                height={128}
                alt="QR Code"
              />

              <p className="mb-0 pt-2 text-center font-poppins text-10xs tracking-[0.15em] lg:text-7xs">
                LISTEN ON BT APP
              </p>
            </div>
          ) : (
            <ButtonFactory
              buttonType={ButtonType.Link}
              text="Listen on BT App"
              link={isIOS ? IOS_APP_LINK : ANDROID_APP_LINK}
              mask={ButtonType.Primary}
              className="mx-auto w-max bg-white py-4 text-xs font-medium leading-normal hover:bg-white hover:text-gray-850"
            />
          )}
        </div>
      </div>

      <div className="my-4 h-[1px] w-full bg-gray-175" />
    </>
  );
};

export default PodcastsPromoteBannerVersion1;
